export const ChatBubble = () => (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.5 12V12.01M8.5 12V12.01M16.5 12V12.01M3.5 20.0001L4.8 16.1001C3.67644 14.4384 3.26999 12.4705 3.65622 10.5624C4.04244 8.65427 5.19506 6.93575 6.89977 5.72635C8.60447 4.51696 10.7453 3.89898 12.9241 3.98732C15.1029 4.07566 17.1715 4.86431 18.7453 6.20664C20.319 7.54896 21.2909 9.35362 21.4801 11.2851C21.6693 13.2165 21.063 15.1433 19.7739 16.7072C18.4848 18.2711 16.6007 19.3657 14.4718 19.7874C12.3429 20.2092 10.1142 19.9294 8.2 19.0001L3.5 20.0001Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </svg>
)
